import * as React from "react";
const SvgFiRrCurveArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-curve-arrow_svg__a)">
      <path
        fill="#062147"
        d="m23.694 19.261-2.396-2.396a.76.76 0 0 0-1.298.537v1.424c-.796-.482-1.593-1.964-2.256-3.209C16.754 13.757 15.82 12 14.25 12s-2.504 1.757-3.494 3.617C9.954 17.124 8.956 19 8 19h-.76c.667-1.393 1.245-3.435 1.89-5.717.692-2.449 1.98-7.008 2.85-7.286.065.02.678.285 1.703 3.322a1 1 0 0 0 1.895-.64c-.82-2.431-1.82-4.68-3.577-4.68-2.213 0-3.264 3.321-4.795 8.739-.566 2.003-1.193 4.209-1.8 5.454A2 2 0 0 1 5 16.999V4h1.56a.76.76 0 0 0 .536-1.298L4.7.306a1.045 1.045 0 0 0-1.478 0L.826 2.702A.76.76 0 0 0 1.363 4H3v13c0 2.206 1.794 4 4 4h13v1.598a.76.76 0 0 0 1.298.537l2.396-2.396c.408-.408.41-1.07.001-1.478m-11.172-2.705c.46-.864 1.315-2.471 1.721-2.557.421.086 1.276 1.693 1.736 2.557.44.828.908 1.693 1.442 2.443h-6.34c.533-.75 1-1.616 1.441-2.443"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-curve-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCurveArrow;
